<script>
	import Helper from '../../Models/Helper';
	import Gallery from '../../States/Gallery';
	import Product from '../../States/Product';

	let shown = [];
	let unseen = true;
	let confirmed = false;
	let notice_confirmed = false;

	function partActive(part) {
		let active = false;
		scan:
			for (let property of part.properties)
				for (let option of property.options)
					if (option.active) {
						active = true;
						break scan;
					}

		return active;
	}

	function activeOption(part) {
		for (let property of part.properties)
			for (let option of property.options)
				if (option.active)
					return option;
	}

	function activeOptions(part) {
		var options = [];
		for (let property of part.properties)
			for (let option of property.options)
				if (option.active)
					options.push(option.name);

		return options.join(', ');
	}

	function seen() {
		let seen = true;
		for (let part of $Product.api.parts)
			if (!shown[part.name]) {
				seen = false;
				break;
			}

		return seen;
	}

	function select(part) {
		$Product.properties = part.properties;
		$Product.options = true;
		$Product.options_top = true;
		shown[part.name] = true;
		unseen = !seen();
	}

	function basket() {
		$Product.basket = true;
		$Product.options = false;
		$Product.info = false;
		notice_confirmed = false;
	}

	function tryBasket() {
		notice_confirmed = !confirmed;
	}
</script>

<style>
	div.phd-group {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 100%;
		margin-bottom: 2em;
		cursor: pointer;
	}

	div.phd-group:last-child {
		margin-bottom: 0;
	}

	div.phd-group-label {
		width: calc(100% - 9.75em);
		padding: 1em 2em;
	}

	div.phd-group-label div {
		color: var(--phd-primary);
		font-size: 1.4em;
		line-height: 1em;
	}

	div.phd-group-label div:first-child {
		font-weight: 600;
		padding-bottom: .75em;
	}

	div.phd-group-label div:last-child {
		color: var(--phd-quaternary);
	}

	div.phd-group.phd-seen div.phd-group-label div:last-child {
		font-weight: 600;
		color: var(--phd-secondary);
	}

	div.phd-group-icon {
		color: var(--phd-quaternary);
		width: 1.75em;
		padding-top: 2.15em;
	}

	div.phd-footer-notice {
		position: absolute;
		background: var(--phd-secondary);
		text-align: center;
		font-size: 1.25em;
		font-weight: 600;
		color: #FFF;
		bottom: -5em;
		padding: .75em 1em;
		border-radius: .5em;
		width: 100%;
		opacity: 0;
		transition: bottom .2s ease-out, opacity .2s ease-out;
		will-change: bottom, opacity;
	}

	div.phd-footer-notice.phd-show {
		bottom: 5em;
		opacity: 1;
	}
</style>

{#if Helper.is($Product.api)}
	<div class="phd-layout">
		<div class="phd-header phd-duo">
			<div>
				<span>Deurmodel</span> {$Product.api.name}
				<div>Incl. meten en monteren</div>
			</div>
			<div>€ {$Product.price}</div>
		</div>
		<div class="phd-body">
			{#each $Product.api.parts as part}
				{#if partActive(part)}
					<div class="phd-group" class:phd-seen="{shown[part.name]}" on:click="{event => select(part)}">
						<div class="phd-option" class:phd-active="{shown[part.name]}">
							<img src="{activeOption(part).images.gallery.small}" alt="{part.name}"/>
						</div>
						<div class="phd-group-label">
							<div>{part.name}</div>
							<div>{activeOptions(part)}</div>
						</div>
						<div class="phd-group-icon">
							<svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M417.8 315.5l20-20c3.8-3.8 10.2-1.1 10.2 4.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h292.3c5.3 0 8 6.5 4.2 10.2l-20 20c-1.1 1.1-2.7 1.8-4.2 1.8H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V319.7c0-1.6.6-3.1 1.8-4.2zm145.9-191.2L251.2 436.8l-99.9 11.1c-13.4 1.5-24.7-9.8-23.2-23.2l11.1-99.9L451.7 12.3c16.4-16.4 43-16.4 59.4 0l52.6 52.6c16.4 16.4 16.4 43 0 59.4zm-93.6 48.4L403.4 106 169.8 339.5l-8.3 75.1 75.1-8.3 233.5-233.6zm71-85.2l-52.6-52.6c-3.8-3.8-10.2-4-14.1 0L426 83.3l66.7 66.7 48.4-48.4c3.9-3.8 3.9-10.2 0-14.1z"></path></svg>
						</div>
					</div>
				{/if}
			{/each}
		</div>
		<div class="phd-footer" class:phd-duo="{notice_confirmed}">
			<div class="phd-footer-notice" class:phd-show="{notice_confirmed}">Is jouw plafondhoge deur zo volledig naar wens?</div>
			{#if notice_confirmed}
				<div>
					<div class="phd-button phd-secondary" on:click="{event => notice_confirmed = false}">
						<svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg>
					</div>
				</div>
				<div>
					<div class="phd-button" on:click="{event => basket()}">
						<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"></path></svg>
					</div>
				</div>
			{:else}
				<div class="phd-button" class:phd-secondary="{unseen}" on:click="{event => tryBasket()}">
					{#if $Product.erp}
						Product aanpassen
					{:else}
						Verder
					{/if}
				</div>
			{/if}
		</div>
	</div>
{/if}